import React, { useState } from "react";
import { Box, Paper, Tooltip, IconButton, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const TruncatableTableCell = ({
  value,
  maxPreviewLength = 50,
  startLength = 20,
  endLength = 20,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);

  if (value === null || value === undefined) {
    value = "Resource not available";
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shouldTruncate = value?.length > maxPreviewLength;
  const truncatedValue = shouldTruncate
    ? `${value.substring(0, startLength)}...${value.substring(value.length - endLength)}`
    : value;

  return (
    <Box sx={{ maxWidth: "100%", py: 0.5 }}>
      <Paper
        elevation={0}
        sx={{
          p: 1,
          bgcolor: "rgba(0,0,0,0.04)",
          borderRadius: 1,
          border: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.75rem",
              color: "text.secondary",
              wordBreak: "break-all",
              flex: 1,
            }}
          >
            {expanded ? value : truncatedValue}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
            {shouldTruncate && (
              <Tooltip title={expanded ? "Show less" : "Show full"}>
                <IconButton
                  sx={{ p: 0.25, mr: 0.5 }}
                  size="small"
                  onClick={() => setExpanded(!expanded)}
                >
                  {expanded ? (
                    <ExpandLessIcon fontSize="small" />
                  ) : (
                    <ExpandMoreIcon fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
              <IconButton sx={{ p: 0.25 }} size="small" onClick={handleCopy}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default TruncatableTableCell;
